"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexGrow: 1,
        minWidth: 200,
        appearance: 'none',
        boxSizing: 'border-box',
        outline: 'none',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.grey5,
        backgroundColor: theme.grey9,
        borderRadius: 2,
        flexShrink: 0,
        cursor: 'default',
        height: constants_1.MIN_TARGET_SIZE + 2,
        paddingLeft: 7,
        paddingRight: 7,
        fontSize: 14,
        fontWeight: 400,
        color: theme.grey1,
        transition: 'border-color 150ms linear 0ms',
        '&[disabled]': {
            opacity: 0.3
        },
        '&:focus': {
            borderColor: theme.indigo3
        },
        '&[data-has-value="true"]:not(:focus):not([data-is-invalid="true"]):not([data-is-caution="true"]):not([data-is-valid="true"]):not([data-is-modified="true"])': {
            borderColor: theme.grey2
        },
        '&[data-is-invalid="true"]': {
            borderColor: theme.warningRed
        },
        '&[data-is-caution="true"]': {
            borderColor: theme.cautionOrange
        },
        '&[data-is-valid="true"]': {
            borderColor: theme.validGreen
        },
        '&[data-is-modified="true"]': {
            borderColor: theme.teal1
        },
        '&[data-has-value="false"]': {
            color: theme.grey4
        }
    },
    value: {
        flexGrow: 1
    },
    icon: {
        color: theme.grey3
    }
});
//# sourceMappingURL=select.button.style.js.map